module.exports = __webpack_public_path__ + "media/application/images/ui/gold-member-bbc34afa4d70e4cff347e579d2e05478.png";